import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import App from "./App";
import { NOTIFY_DURATION_MS } from "./lib/notify";
import "./styles/index.css";
import { ensureUiCatalog, initialLanguage } from "./i18n";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Floor row 10 (Track F): only the English catalog is in the entry chunk; the
// resolved language's catalog (if another) is fetched before the first render
// so no page ever flashes English or raw keys.
await ensureUiCatalog(initialLanguage);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {/* The toaster carries the tokens (ENG-APP-UX-TUNEUP Track D; spec § 2
          Toast: ink surface, 8 px radius, max 520 px, 14 px); the durations and
          the one action live in `lib/notify.ts`. No raw hex: every colour is a
          `@theme` token (UI_COMPONENT_CONTRACT § Token surface). */}
      <Toaster
        position="bottom-left"
        toastOptions={{
          duration: NOTIFY_DURATION_MS.info,
          className: "max-w-[520px] rounded-lg text-sm",
          style: {
            background: "var(--color-ink)",
            color: "var(--color-surface)",
          },
          success: {
            duration: NOTIFY_DURATION_MS.success,
            iconTheme: {
              primary: "var(--color-success)",
              secondary: "var(--color-surface)",
            },
          },
          error: {
            duration: NOTIFY_DURATION_MS.error,
            iconTheme: {
              primary: "var(--color-error)",
              secondary: "var(--color-surface)",
            },
          },
        }}
      />
    </QueryClientProvider>
  </StrictMode>,
);
